import PDMO from "@/api/PDMO";

export const pdmo = {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
        async searchPDMO(params, data) {
            return new Promise((resolve, reject) => {
                PDMO.search(data)
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
        async getPDMaoObra(params, id) {
            return new Promise((resolve, reject) => {
                PDMO.getMaoObra(id)
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        }
    }    
}